module.exports = __webpack_public_path__ + "img/IMG_9458_59_60_L_BlackMatted.12d1f2df.jpg";